module.exports = __webpack_public_path__ + "img/ring_g_skip_null_null.96ad4d11.png";